import {useState} from "react";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {DropdownAction, DropdownActionItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {MaintenanceOccurrence} from "@/lib/types/maintenance.ts";
import {EndActiveWindowDialog} from "@/pages/maintenance/maintenance-dashboard/tabs/active-occurrences/actions/EndActiveWindowDialog.tsx";

interface ActiveOccurrenceActionsProps {
  occurrence: MaintenanceOccurrence;
}

export const ActiveOccurrenceActions = ({occurrence}: ActiveOccurrenceActionsProps) => {
  const [showEndDialog, setShowEndDialog] = useState(false);

  //TODO manual schedules need to be changed in the check, implement when that is done
  const editLink =
    occurrence.schedule.schedule_type === "MANUAL"
      ? `/checks/${occurrence.schedule.services[0]?.id}/edit?tab=maintenance_v2`
      : `/maintenance/schedules/${occurrence.schedule.id}/edit`;

  const editLabel = occurrence.schedule.schedule_type === "MANUAL" ? "Edit" : "Edit Schedule";

  const actionsBarItems = [
    <DropdownActionItem key="end" text="End Maintenance" onClick={() => setShowEndDialog(true)} />,
    <Button key="edit" variant={"dropdownMenuItem"} as={Link} to={editLink}>
      {editLabel}
    </Button>,
  ];

  return (
    <>
      <DropdownAction id={`occurrence-actions-${occurrence.id}`} items={actionsBarItems} />
      <EndActiveWindowDialog occurrence={occurrence} show={showEndDialog} onClose={() => setShowEndDialog(false)} />
    </>
  );
};
